angular.module('core')
    .service('compareDay', ['translateFilter', 'moment', function(translateFilter, $moment) {
        var today = $moment();
        var groupedByDate = today;
        var unitSet = 'day';
        var count = 0;

        // Resets the date used for grouping.
        // @param alwaysIncludeFirstDate if set to true then the first passed date will be considered as a "different day"
        //        (or put another way isDifferentDay(date) will return true)
        // @TODO: Refactor to reset on controller/pane change...
        //        Remove instances form controllers
        var resetGroupedByDate = function(alwaysIncludeFirstDate) {
          if (alwaysIncludeFirstDate === true) {
              // this means first passed date will be always considered as a different day
              groupedByDate = null;
          } else {
              // else set it to "today"
              groupedByDate = $moment();
          }
          count = 0;
        };

        var getCount = function() {
            return count;
        };

        var updateCount = function() {
            count++;
        };

        var isDifferentDay = function(timestamp) {

          var timestampDay = $moment(timestamp);

          if (groupedByDate !== null && $moment(groupedByDate).isSame(timestampDay, 'day') ) {
            // do nothing
            return false;
          } else {
            // if date doesn't match, update groupedByDate
            groupedByDate = timestampDay;
            return true;
          }
        };

        var isDifferent = function(unit, timestamp) {
            var _timestamp =  $moment(timestamp);
            var _unit = unit;

            count++;

            if (unitSet !== _unit) {
                unitSet = _unit;
                resetGroupedByDate();
            }

            if (groupedByDate !== null && $moment(groupedByDate).isSame(_timestamp, _unit) ) {
                // do nothing
                return false;
            } else {
                // if date doesn't match, update groupedByDate
                // day, week, or month
                var label = '';
                groupedByDate = _timestamp;

                switch (_unit) {
                    case 'day':
                        label = _timestamp;
                        break;
                    case 'week':
                        label = translateFilter('assignments.weekOf', { date: $moment(_timestamp).startOf('week').format('L') });
                        break;
                    case 'month':
                        label = translateFilter('assignments.monthOf', { date: $moment(_timestamp).format('MMMM YYYY') });
                        break;
                    default:
                        label = '';
                }
                return label;
            }
        };

        return {
            getCount: getCount,
            updateCount: updateCount,
            isDifferentDay: isDifferentDay,
            isDifferent: isDifferent,
            resetGroupedByDate: resetGroupedByDate
        };

    }]);
